import { Lock, Server, Key, FileCheck, AlertTriangle, CheckCircle2 } from "lucide-react";
import { Eyebrow, HeadlineDuo } from "../components/brand";

export function SecurityPage() {
  const sections = [
    {
      title: "Authentifizierung",
      icon: Lock,
      color: "var(--color-primary)",
      items: [
        { label: "JWT + HttpOnly Cookies", status: "active", detail: "7 Tage Gueltigkeit" },
        { label: "TOTP MFA", status: "active", detail: "6-stellig, 30s Window" },
        { label: "Rate-Limiting", status: "active", detail: "5 Versuche / 60s" },
        { label: "bcrypt Hashing", status: "active", detail: "12 Runden" },
      ],
    },
    {
      title: "DSGVO-Konformitaet",
      icon: FileCheck,
      color: "var(--color-success)",
      items: [
        { label: "Art. 5: Audit-Log", status: "active", detail: "Alle Aktionen protokolliert" },
        { label: "Art. 15: Auskunftsrecht", status: "active", detail: "CSV-Export verfuegbar" },
        { label: "Art. 17: Recht auf Loeschung", status: "active", detail: "Soft-Delete implementiert" },
        { label: "Art. 25: Privacy by Design", status: "active", detail: "Rollenbasierte Zugriffskontrolle" },
      ],
    },
    {
      title: "Infrastruktur",
      icon: Server,
      color: "var(--color-info)",
      items: [
        { label: "PostgreSQL", status: "active", detail: "Railway EU (Frankfurt)" },
        { label: "Secrets Management", status: "active", detail: "Railway ENV + GitHub Secrets" },
        { label: "GitHub Security", status: "active", detail: "Dependabot + Secret Scanning" },
        { label: "HTTPS / TLS", status: "active", detail: "Railway managed" },
      ],
    },
    {
      title: "Datenklassen",
      icon: Key,
      color: "var(--color-warning)",
      items: [
        { label: "A — Oeffentlich", status: "info", detail: "Alle Tools erlaubt" },
        { label: "B — Intern", status: "info", detail: "Claude, M365, Notion" },
        { label: "C — Vertraulich", status: "warn", detail: "M365, Personio — kein Manus" },
        { label: "D — Kritisch", status: "danger", detail: "Nur Railway ENV" },
      ],
    },
  ];

  return (
    <div className="animate-in">
      <div className="mb-10">
        <Eyebrow>Compliance · Uebersicht</Eyebrow>
        <div className="mt-5">
          <HeadlineDuo size="md" rowOne="SECURITY" rowTwo="& DSGVO." />
        </div>
        <p
          className="mt-4 text-sm max-w-[62ch]"
          style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}
        >
          Sicherheitsueberblick und Compliance-Status aller Bausteine.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {sections.map((section, i) => (
          <div key={section.title} className="card p-6" style={{ animationDelay: `${i * 60}ms` }}>
            <div className="flex items-center gap-3 mb-5">
              <div
                className="w-11 h-11 flex items-center justify-center"
                style={{
                  border: "1px solid var(--color-brand-grey-mid, #C6C6C6)",
                  borderRadius: "var(--radius-sm)",
                  color: section.color,
                }}
              >
                <section.icon size={20} strokeWidth={1.5} />
              </div>
              <h3
                className="font-semibold text-sm"
                style={{ fontFamily: "var(--font-display)", color: "var(--color-foreground)" }}
              >
                {section.title}
              </h3>
            </div>
            <div className="flex flex-col gap-2">
              {section.items.map(item => (
                <div
                  key={item.label}
                  className="flex items-center justify-between py-1.5 border-b last:border-b-0"
                  style={{ borderColor: "var(--color-border)" }}
                >
                  <div className="flex items-center gap-2.5">
                    {item.status === "active" && (
                      <CheckCircle2 size={14} strokeWidth={1.5} style={{ color: "var(--color-success)" }} />
                    )}
                    {item.status === "info" && (
                      <CheckCircle2 size={14} strokeWidth={1.5} style={{ color: "var(--color-info)" }} />
                    )}
                    {item.status === "warn" && (
                      <AlertTriangle size={14} strokeWidth={1.5} style={{ color: "var(--color-warning)" }} />
                    )}
                    {item.status === "danger" && (
                      <AlertTriangle size={14} strokeWidth={1.5} style={{ color: "var(--color-danger)" }} />
                    )}
                    <span className="text-sm" style={{ color: "var(--color-foreground)" }}>{item.label}</span>
                  </div>
                  <span
                    className="text-[10px]"
                    style={{ color: "var(--color-muted)", fontFamily: "var(--font-mono)", letterSpacing: "0.08em" }}
                  >
                    {item.detail}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
